export class EnderecoService {

	buscarCEP(cep) {
		return fetch(`https://viacep.com.br/ws/${cep}/json`).then((result) => result);
	}

}
